module.exports = __webpack_public_path__ + "7bc70ad50f9e48e5fd8b9ca57c37e40a.jpg";